import { createRouter, createWebHistory, type RouteRecordRaw, type Router } from 'vue-router'
import authMiddleware from '@/middleware/auth'
// 导入路由组件
import Dashboard from '@/views/Dashboard.vue'
import Login from '@/views/Login.vue'
import NotFound from '@/views/NotFound.vue'
import BetsList from '@/views/bets/BetsList.vue'
import AnomalyBetsList from '@/views/bets/AnomalyBetsList.vue'
import PlayersList from '@/views/players/PlayersList.vue'
// 新增路由组件
import BetsReports from '@/views/bets/BetsReports.vue'
import BetsComparison from '@/views/bets/BetsComparison.vue'
import BalanceLogs from '@/views/players/BalanceLogs.vue'
// 系统管理路由组件
import SystemPerformance from '@/views/system/SystemPerformance.vue'
import SystemVendorCallbacks from '@/views/system/VendorCallbacks.vue'
import SystemAlerts from '@/views/system/SystemAlerts.vue'
import SystemLogs from '@/views/system/SystemLogs.vue'

// 创建API客户端实例
const routes: RouteRecordRaw[] = [
  {
    path: '/admin/login',
    name: 'login',
    component: Login,
    meta: {
      title: '登录', 
      requiresAuth: false 
    } ,
    beforeEnter: authMiddleware.guest
  },
  {
    path: '/admin/dashboard',
    name: 'dashboard',
    component: Dashboard,
    meta: { 
      title: '仪表盘', 
      requiresAuth: true 
    } 
  },
  {
    path: '/admin/bets',
    name: 'bets',
    component: BetsList,
    meta: { 
      title: '投注记录', 
      requiresAuth: true 
    } 
  },
  {
    path: '/admin/bets/anomaly',
    name: 'bets-anomaly',
    component: AnomalyBetsList,
    meta: { 
      title: '异常注单', 
      requiresAuth: true 
    } 
  },
  {
    path: '/admin/bets/reports',
    name: 'bets-reports',
    component: BetsReports,
    meta: { 
      title: '注单报表', 
      requiresAuth: true 
    } 
  },
  {
    path: '/admin/bets/comparison',
    name: 'bets-comparison',
    component: BetsComparison,
    meta: { 
      title: '注单对比', 
      requiresAuth: true 
    } 
  },
  {
    path: '/admin/players',
    name: 'players',
    component: PlayersList,
    meta: { 
      title: '玩家管理', 
      requiresAuth: true 
    } 
  },
  {
    path: '/admin/players/balance-logs',
    name: 'players-balance-logs',
    component: BalanceLogs,
    meta: { 
      title: '余额变动记录', 
      requiresAuth: true 
    } 
  },
  // 系统管理路由
  {
    path: '/admin/system/performance',
    name: 'system-performance',
    component: SystemPerformance,
    meta: {
      title: '系统性能监控',
      requiresAuth: true
    } 
  },
  {
    path: '/admin/system/vendor-callbacks',
    name: 'system-vendor-callbacks',
    component: SystemVendorCallbacks,
    meta: {
      title: '供应商回调管理',
      requiresAuth: true
    } 
  },
  {
    path: '/admin/system/alerts',
    name: 'system-alerts',
    component: SystemAlerts,
    meta: {
      title: '系统报警',
      requiresAuth: true
    } 
  },
  {
    path: '/admin/system/logs',
    name: 'system-logs',
    component: SystemLogs,
    meta: {
      title: '系统日志',
      requiresAuth: true
    } 
  },
  // 重定向
  {
    path: '/admin',
    redirect: '/admin/dashboard'
  },
  {
    path: '/',
    redirect: '/admin/dashboard'
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: NotFound
  }
]

const router: Router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

// 路由守卫
router.beforeEach(async (to, from, next) => {
  // 设置页面标题
  const title = (to.meta )?.title;
  document.title = title ? `${title} - 游戏管理系统 - TypeScript版` : '游戏管理系统 - TypeScript版'
  
  // 使用认证中间件
  await authMiddleware.auth(to, from, next)
})

export default router
